import blog1 from '../assets/png/Blog/angular-tip.png';
import blog2 from '../assets/png/Blog/docker-blog.png';
import blog3 from '../assets/png/Blog/javasc-typsc.png';
import blog4 from '../assets/png/Blog/basic-website.png';
import blog5 from '../assets/png/Blog/what-techniques-for-web.png';
import blog6 from '../assets/png/Blog/spring-difference.png';

export const blogData = [
    {
        id: 1,
        title: 'How can I become an expert in AngularJS and NodeJS?',
        description: 'JS Basics, Node.js run time, Nodejs component, Node.js patterns, Angular architecture.',
        date: 'May 12, 2020',
        image: blog1,
        url: 'https://olehkimak.blogspot.com/2023/11/how-can-i-become-expert-in-angularjs.html'
    },
    {
        id: 2,
        title: 'What is Docker? When should I use Docker?',
        description: 'If it runs in your system, it runs anywhere in the world.',
        date: 'Jan 5, 2023',
        image: blog2,
        url: 'https://olehkimak.blogspot.com/2023/11/what-is-docker-when-should-i-use-docker.html'
    },
    {
        id: 3,
        title: "What's the difference between JavaScript and TypeScript?",
        description: 'Typescript is more object-oriented compared to Javascript (including ES7/ ES8+ etc.) because...',
        date: 'Apr 18, 2019',
        image: blog3,
        url: 'https://olehkimak.blogspot.com/2023/11/whats-difference-between-javascript-and.html'
    },
    {
        id: 4,
        title: 'How should I go about starting my first website?',
        description: 'Start by learning HTML and CSS so you know what makes up the skeleton and skin of a website. Then learn...',
        date: 'Nov 6, 2017',
        image: blog4,
        url: 'https://olehkimak.blogspot.com/2023/11/how-should-i-go-about-starting-my-first.html'
    },
    {
        id: 5,
        title: 'What is the single most important skill a programmer should have?',
        description: 'First off, you need to know that a web developer is not a web designer. So, no, Photoshop is ...',
        date: 'Sep 11, 2019',
        image: blog5,
        url: 'https://olehkimak.blogspot.com/2023/11/what-is-single-most-important-skill.html'
    },
    {
        id: 6,
        title: 'What is the difference between Spring Boot and the Spring framework?',
        description: 'Both Spring Framework & Spring Boot are used to create Java Enterprise applications. One could do..',
        date: 'Nov 12, 2021',
        image: blog6,
        url: 'https://olehkimak.blogspot.com/2023/11/what-is-difference-between-spring-boot.html'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/